import OrdersListForReturn from '@stone/components/account/OrdersListForReturn';
import { OrdersActionTypes } from '@state/features/common.types';
import { getReturnableOrders } from '@state/features/orders.selectors';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ClientServiceSection from './ClientServiceSection';
import EmptyListMessage from '../common/EmptyListMessage';
import useMediaQueries from '@stone/hooks/useMediaQueries';
const ReturnsOrdersListing = (props) => {
    const { t } = useTranslation();
    const { loading, orders } = useSelector(getReturnableOrders);
    const { isMobile } = useMediaQueries();
    const dispatch = useDispatch();
    const [order, setOrder] = useState();
    useEffect(() => {
        if (loading) {
            dispatch({
                type: OrdersActionTypes.FETCH_ORDERS,
            });
        }
    }, []);
    const eligibleOrders = useMemo(() => {
        if (!orders) {
            return [];
        }
        if (props.onlyEligibleForExchange) {
            return orders.filter((o) => o.isEligibleForExchange || o.isEligibleForReturnInDifferentCountry);
        }
        return orders;
    }, [orders]);
    if (loading) {
        return React.createElement(React.Fragment, null);
    }
    if ((eligibleOrders === null || eligibleOrders === void 0 ? void 0 : eligibleOrders.length) === 0) {
        return (React.createElement(React.Fragment, null,
            React.createElement(ClientServiceSection, { noMargin: true, title: t('returns.noorderfound'), description: props.description, introSection: true, className: "no-order-found" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-24 col-lg-12" },
                        React.createElement(EmptyListMessage, { buttonLink: props.orderspageurl, buttonText: t('button.findorder'), className: ` orders-history__empty-message`, text: t('returns.noordereligible'), 
                            // pushAnalytics={() => analytics.ordersTwo()}
                            fullButton: true, mb: isMobile ? 20 : 32 }))))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(ClientServiceSection, { noMargin: true, title: props.title, description: props.description, introSection: true },
            React.createElement("p", { className: "orders-listing__intro" }, props.isExchange ? t('exchange.selectitems') : t('returns.selectitems')),
            React.createElement(OrdersListForReturn, { callback: (order) => setOrder(order), onlyreturnable: true, hideButtons: true, inReturn: props.isReturn, inExchange: props.isExchange, onlyEligibleForExchange: props.onlyEligibleForExchange, orderNumberActive: order === null || order === void 0 ? void 0 : order.orderNumber, orders: eligibleOrders, openreturnurl: props.openreturnurl, openexchangeurl: props.openexchangeurl }))));
};
export default ReturnsOrdersListing;
